import { render, staticRenderFns } from "./AslicePagination.vue?vue&type=template&id=44adbb57&scoped=true&"
import script from "./AslicePagination.vue?vue&type=script&lang=js&"
export * from "./AslicePagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44adbb57",
  null
  
)

export default component.exports